export enum LocalStorageKeys {
    Token = 'token',
    Language = 'language',
    CompanionLanguage = 'companion.language',
    MoverDashboard = 'mover-dashboard',
    DiyFilingWater = 'diy-filing-water',
}
